export class Header {
  value: string;
  id: string;
  name: string;
  colspan: number;
}
